import { Component } from 'react';
import PropTypes from 'prop-types';

import { logger } from '../../lib/logger';
import { themes } from '../../lib/themes';
import ErrorDisplay from '../ErrorDisplay';

class ErrorPage extends Component {
  static propType = {
    theme: PropTypes.oneOf(themes),
  };
  static defaultProps = {
    theme: 'waybetter',
  };
  state = {
    error: null,
  };

  componentDidCatch(error) {
    this.setState({ error });
    logger.error(error);
  }

  render() {
    const { theme } = this.props;
    const { error } = this.state;

    if (error)
      return (
        <ErrorDisplay
          theme={theme}
          errors={Array.isArray(error) ? error : [error]}
        />
      );

    return this.props.children;
  }
}

export default ErrorPage;
